import React, { Component } from 'react';
import $ from 'jquery';
import axios from 'axios';
import { URL } from '../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { showSuccessMsg } from '../../util/messagesUtil';
import { formatCPF } from '../../util/numberUtil';

export class ModalEditarClientePontos extends Component {
    constructor(props) {
        super(props);
        this.state = { nome: '', email: '', telefone: '', salvando: false };
        this.fecharModal = this.fecharModal.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.cliente && this.props.cliente !== prevProps.cliente) {
            this.setState({
                nome: this.props.cliente.nome || '',
                email: this.props.cliente.email || '',
                telefone: this.props.cliente.telefone || '',
            });
        }
    }

    fecharModal() {
        $('#modalEditarClientePontos').modal('hide');
        $('#modalEditarClientePontos').hide();
        $('.modal-backdrop').hide();
    }

    submit(e) {
        e.preventDefault();
        const { cliente } = this.props;
        if (!cliente) return;
        this.setState({ salvando: true });
        axios.put(`${URL}/cliente/${cliente.id}`, {
            nome: this.state.nome,
            email: this.state.email,
            telefone: this.state.telefone,
        }, SLOW_REQUEST_CONFIG)
            .then(() => {
                showSuccessMsg('Dados do cliente atualizados com sucesso!');
                this.fecharModal();
                if (this.props.onSalvar) this.props.onSalvar();
            })
            .finally(() => this.setState({ salvando: false }));
    }

    render() {
        const { cliente } = this.props;
        const { nome, email, telefone, salvando } = this.state;

        return (
            <div className="modal fade show" id="modalEditarClientePontos" role="dialog"
                aria-labelledby="modalEditarClientePontos" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content vx-modal-content">

                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">edit</i>
                                <span className="vx-modal-title">Editar Cliente</span>
                            </div>
                            <button type="button" className="vx-modal-close" onClick={this.fecharModal}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>

                        <div className="vx-modal-body">
                            {cliente && (
                                <form id="form-editar-cliente-pontos" onSubmit={this.submit}>
                                    <div className="vx-config-card" style={{ marginBottom: 0 }}>
                                        <div className="vx-config-card-header">
                                            <i className="material-icons">person</i>
                                            <div className="vx-config-card-header-text">
                                                <h6>Dados do Cliente</h6>
                                                <small>CPF: {formatCPF(cliente.cpf)} · ID #{cliente.id}</small>
                                            </div>
                                        </div>
                                        <div className="vx-config-card-body">
                                            <div style={{ marginBottom: 14 }}>
                                                <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Nome completo:</label>
                                                <input type="text" className="form-control"
                                                    value={nome}
                                                    onChange={e => this.setState({ nome: e.target.value })}
                                                    required />
                                            </div>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                                                <div>
                                                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>E-mail:</label>
                                                    <input type="email" className="form-control"
                                                        value={email}
                                                        onChange={e => this.setState({ email: e.target.value })} />
                                                </div>
                                                <div>
                                                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Telefone:</label>
                                                    <input type="text" className="form-control"
                                                        value={telefone}
                                                        onChange={e => this.setState({ telefone: e.target.value })} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>

                        <div className="vx-modal-footer">
                            <button type="button" className="vx-btn-secondary" onClick={this.fecharModal}>
                                Cancelar
                            </button>
                            <button type="submit" form="form-editar-cliente-pontos"
                                disabled={salvando}
                                className="vx-btn-primary">
                                <i className="material-icons" style={{ fontSize: 16 }}>save</i>
                                {salvando ? 'Salvando...' : 'Salvar'}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default ModalEditarClientePontos;
